module.exports = __webpack_public_path__ + "img/join_us2.e8118795.jpg";